{
  "all-listings": {
    "disconnected": {
      "text": "Crea tu cuenta o inicia sesión para ver los recursos disponibles en la red Partage Agricole."
    },
    "needLogin": {
      "secondLine": "Crea tu cuenta o inicia sesión para ver los recursos disponibles en la red Partage Agricole."
    },
    "empty": {
      "offer": {
        "firstLine": "¡Comienza tu aventura aquí!",
        "primaryButtonText": "¡Publica una oferta!",
        "secondLine": "Participa en el catálogo ofreciendo objetos para prestar."
      },
      "invite": {
        "primaryButtonText": "Invita a los demás miembros",
        "secondLine": "Invita a los demás miembros o publica una oferta en tu barrio."
      }
    },
    "banner": {
      "xmas": {
        "text": "¡Se acercan las fiestas! Ayuda a los demás miembros a encontrar estos objetos tan solicitados."
      }
    },
    "inviteOthersPrompt": {
      "ctaButton": "Invita a los demás miembros"
    },
    "postOfferPrompt": {
      "firstAfter": {
        "button": "Invitar a los demás miembros",
        "title": "¡Invita a los demás miembros!"
      },
      "third": {
        "title": "Pregunta a los demás miembros"
      }
    }
  },
  "common": {
    "appName": "Partage Agricole",
    "appDownloadPrompt": {
      "guest": "¿Te gusta lo que ves? Lleva Partage Agricole en tu teléfono y recibe nuevas disponibilidades cerca de ti",
      "qrCodeAccessibilityLabel": "Código QR para descargar la aplicación Partage Agricole"
    }
  },
  "contact-information": {
    "prompt": "Agrega el código postal de la empresa para ver qué objetos están disponibles en los alrededores.",
    "title": "Tu dirección",
    "prompt-public": "Agrega tu código postal para ver los anuncios disponibles en los alrededores.",
    "title-public": "Tu código postal"
  },
  "contact-us": {
    "firstParagraph": "El servicio a los miembros de Partage Agricole está disponible por correo electrónico y mensajería. Te responderemos lo más rápido posible.",
    "faqLink": "https://www.partageagricole.ca/faq",
    "chatPrompt": {
      "bugReport": "¡Hola! 😊\n\nGracias por explicarnos qué está fallando.",
      "suggestion": "¡Hola! 😊\n\nSiempre estamos abiertos a sugerencias. Gracias por ayudarnos a mejorar nuestro servicio.\n\n¡Gracias!"
    }
  },
  "credentials": {
    "activationCodeFieldHelp": "Solo los socios de Partage Agricole pueden usar esta aplicación. Para obtener el código de invitación, contacta a <a>Partage Agricole</a>.",
    "activationCodeFieldHelpLink": "https://www.partageagricole.ca/s-inscrire"
  },
  "guidelines": {
    "fifthParagraph": "No utilizar Partage Agricole para vender objetos.",
    "startingKit": "Quiero recibir el <startingKitLink>Kit de inicio</startingKitLink> por correo para reclutar a los demás miembros (opcional)"
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Se unió a Partage Agricole",
        "title": "Explorador"
      }
    }
  },
  "introModal": {
    "title": "Estimado/a {{name}},",
    "first": "¡Gracias por unirte a la comunidad y dar un primer paso hacia la reducción de tu consumo y la creación de nuevos lazos!",
    "second": "<strong>Compartir es una muestra de confianza</strong>: ¡cuanto más prestes, más ganas tendrán los demás de prestarte!",
    "third": "<strong>Sabe que menos del 0,1 % de todos los intercambios</strong> generan un daño. Y no es por mala fe. Es simplemente normal cuando los objetos se usan un poco más.",
    "notInsurable": {
      "community": "<strong>Es la oportunidad perfecta para conocer a los demás miembros</strong> y dar un paso hacia un mundo más sostenible."
    },
    "welcome": {
      "withWho": {
        "enterprise": "tus colegas y otros miembros",
        "municipal": "los demás miembros",
        "municipal_closed": "los demás miembros",
        "realestate": "los demás miembros"
      }
    }
  },
  "my-information": {
    "firstNameFieldLabel": "Nombre de la empresa",
    "credentialInformationTitle": "Cuenta y seguridad",
    "personalInformationTitle": "Información del perfil"
  },
  "my-personal-information": {
    "firstNameFieldLabel": "Nombre de la empresa",
    "firstNameFieldPlaceholder": "ej. Granja de la Torre de Plata",
    "title": "Información del perfil"
  },
  "my-plan": {
    "businessPlan": {
      "firstParagraph": {
        "enterprise": "Tu suscripción a esta aplicación de mutualización es cortesía de Partage Agricole."
      },
      "title": {
        "enterprise": "Suscripción Partage Agricole"
      }
    },
    "noEnd": "Esta suscripción es válida mientras seas miembro de Partage Agricole.",
    "design": {
      "freeBorrowDescription": "Pide prestado tu primer objeto a los demás miembros gratis",
      "unlimitedLendingDescription": "Publica ofertas y presta tus objetos a los demás miembros tantas veces como quieras"
    }
  },
  "new": {
    "itemInformationSection": {
      "nameFieldPlaceholder": "ej: Tractor de jardín",
      "descriptionFieldPlaceholder": {
        "offer": "Marca, dimensiones, color, peso, estado, año de adquisición, condiciones de préstamo, especificidades del objeto...",
        "request": "Marca, dimensiones, color, peso, estado, año de adquisición, condiciones de préstamo, especificidades del objeto..."
      }
    }
  },
  "notifications": {
    "introModal": {
      "intro": {
        "title": "Bienvenido/a al Club",
        "body": "¡Descubre Partage Agricole!"
      }
    },
    "welcome": "¡Bienvenido/a a Partage Agricole!",
    "welcomeMessage": "Gracias por confiar en nosotros.",
    "rate": {
      "borrower": {
        "message": "Tu opinión es importante para nosotros y para los otros miembros de Partage Agricole."
      },
      "lender": {
        "message": "Tu opinión es importante para nosotros y para los otros miembros de Partage Agricole."
      }
    },
    "loanReciprocity": {
      "message": "Publica los objetos que uses poco y compártelos con los demás miembros."
    }
  },
  "offerAvailability": {
    "refrainPopup": {
      "hi": "Estimado miembro,",
      "text": {
        "lender": {
          "before": "No olvides reservar tus fechas de trabajo y planificar tus días de transporte durante tu reserva.",
          "after": "No olvides reservar tus fechas de trabajo y planificar tus días de transporte."
        },
        "borrower": "No olvides planificar tus días de transporte durante tu préstamo."
      }
    }
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "La necesidad fue cubierta en Partage Agricole"
      }
    }
  },
  "personal-information": {
    "firstNameFieldLabel": "Nombre de la empresa",
    "firstNameFieldPlaceholder": "ej. Granja de la Torre de Plata",
    "pictureFieldSubtitle": "Esta imagen se mostrará en tus anuncios y tu perfil.",
    "pictureFieldTitle": "Agregar una imagen del logo de la empresa",
    "title": "Información del perfil",
    "firstNameFieldLabel-public": "Nombre",
    "firstNameFieldPlaceholder-public": "Nombre",
    "lastNameFieldLabel-public": "Apellido",
    "lastNameFieldPlaceholder-public": "Apellido",
    "phoneFieldLabel-public": "Número de teléfono (opcional)",
    "pictureFieldSubtitle-public": "La foto de perfil aumenta la confianza entre miembros",
    "pictureFieldTitle-public": "Agregar una foto de perfil",
    "title-public": "Tu información personal"
  },
  "privacy": {
    "link1": "https://www.partageagricole.ca/termes-et-conditions",
    "link2": "https://www.partage.club/politique-de-confidentialite",
    "line3": "de Partage Agricole."
  },
  "quick-new-thanks": {
    "bodyText": "¡Acabas de contribuir a enriquecer el catálogo de <strong>Partage Agricole</strong>!\n\nPuedes modificar tus ofertas en cualquier momento en tu centro de intercambios."
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contactar a Partage Agricole"
    }
  },
  "tutorial": {
    "multipleOffers": {
      "step1": {
        "text": "Al ofrecer tus objetos, animas incluso a los horticultores más tímidos a pedir."
      }
    },
    "publishOffers": {
      "step2": {
        "text": "Al ofrecer tus objetos, animas incluso a <strong>los demás miembros más tímidos</strong> a pedir. Siempre puedes prestar tus objetos, <strong>incluso sin suscripción</strong>.\n\nPresiona el ícono para continuar. (2/5)"
      },
      "step2AltCorp": {
        "text": "Al ofrecer tus objetos, animas incluso a <strong>los demás miembros más tímidos</strong> a pedir.\n\nPresiona el ícono para continuar. (2/5)"
      }
    }
  },
  "free-sub": {
    "inviteButtonText": "Invitar a los demás miembros",
    "spreadTheLoveText": "¡Cuéntaselo a los demás miembros para que ellos también puedan aprovechar la oferta especial!"
  },
  "help": {
    "borrower": {
      "steps": {
        "catalog": {
          "text": "Busca un objeto en el catálogo o publica una necesidad visible para los demás miembros"
        },
        "meeting": {
          "text": "Propón y confirma las fechas de préstamo y recogida con el otro miembro"
        },
        "pickup": {
          "text": "Reúnete con el otro miembro en su domicilio o en un lugar público seguro. <strong>¡Sin intercambio de dinero, es gratis!</strong>"
        }
      }
    },
    "guestCta": {
      "text": "Únete a otros miembros y descubre todo lo que puedes pedir prestado cerca de ti."
    },
    "lender": {
      "steps": {
        "share": {
          "text": "Reúnete con el otro miembro en tu domicilio o en un lugar público seguro para entregarle el objeto. <strong>¡Sin intercambio de dinero, es gratis!</strong>"
        }
      }
    }
  },
  "invite": {
    "referralProgram": {
      "shareText": "¡Hola!\n\nUso Partage Agricole, una app genial para prestar y tomar prestados objetos cotidianos entre miembros: herramientas, juegos, material deportivo… ¡todo lo que quieras!\nEstoy seguro/a de que te va a encantar. Únete aquí:\n\n{{url}}"
    },
    "referralProgram202506": {
      "shareText": "¡Hola!\n\nUso Partage Agricole, una app genial para prestar y tomar prestados objetos entre miembros: herramientas, juegos, artículos deportivos… ¡de todo!\nEstoy seguro/a de que te va a interesar. Únete aquí:\n\n{{url}}"
    },
    "shareText": "¡Hola!\n\nUso Partage Agricole, una app genial para prestar y tomar prestados objetos entre miembros: herramientas, juegos, artículos deportivos… ¡de todo!\nEstoy seguro/a de que te va a interesar. Únete aquí:\n\n{{url}}",
    "title": "¡Invita a los demás miembros o personas cercanas!"
  },
  "landing-page": {
    "immature": {
      "referral": {
        "button": "Invita a los demás miembros"
      }
    },
    "requests": {
      "emptyState": {
        "subtitle": "Te avisaremos si los demás miembros necesitan ayuda"
      }
    }
  },
  "loans": {
    "past": {
      "savings": {
        "header": {
          "lending": "Ahorrados por los demás miembros gracias a ti"
        }
      }
    }
  },
  "my-impact-financial": {
    "empty": {
      "lending": {
        "secondLine": "¡Comparte tus objetos y mira cuánto dinero permites ahorrar a los miembros!"
      }
    },
    "emptyByTransaction": {
      "lend": {
        "lending": {
          "secondLine": "¡Comparte tus objetos y mira cuánto dinero permites ahorrar a los miembros!"
        }
      }
    }
  },
  "my-neighbourhood": {
    "radiusDescription": "Tu radio te permite compartir tus anuncios dentro de un perímetro limitado de tu barrio. Los miembros que vivan fuera de esta zona no podrán ver tus anuncios."
  },
  "one-channel": {
    "howItWorks": {
      "borrow": {
        "step2": "<bold>Propón</bold> fechas de préstamo, <bold>espera la confirmación</bold> del otro miembro y <bold>planifiquen la recogida</bold> juntos",
        "step3": "<bold>Recoge el objeto</bold> en casa del otro miembro o en un lugar público seguro. <bold>¡Sin intercambio de dinero, es gratis!</bold>"
      },
      "lend": {
        "step3": "<bold>Presta el objeto</bold> al otro miembro. <bold>¡Sin intercambio de dinero, es gratis!</bold>"
      }
    }
  },
  "payment": {
    "modal": {
      "firstParagraph": "Gracias por tu confianza. Gracias a tu suscripción, ahora puedes tomar prestado y prestar objetos a los demás miembros sin límite."
    }
  },
  "posts": {
    "feed": {
      "endOfFeed": {
        "description": "Un objeto prestado, un nuevo encuentro…\nComparte tu historia con los demás miembros."
      }
    },
    "storyComposer": {
      "neighbour": "un miembro"
    }
  },
  "presentCommunity": {
    "newFlow": {
      "oneFreeBorrowDescription": "Pide prestado tu primer objeto a los demás miembros gratis",
      "unlimitedLendingDescription": "Publica ofertas y presta tus objetos a los demás miembros tantas veces como quieras"
    }
  },
  "presentPartageClub": {
    "community": {
      "headerText": "Partage Agricole es la aplicación de <strong>intercambio de objetos</strong> entre miembros."
    }
  },
  "profile-overview": {
    "inviteNeighboursButtonLabel": "Invitar miembros"
  },
  "recommendations": {
    "urgent-needs": {
      "title": "¡Ayuda a los demás miembros!"
    }
  },
  "streak": {
    "contributions": {
      "add_avatar": {
        "description": "Una foto de perfil tranquiliza a los demás miembros y te hace reconocible en el barrio."
      },
      "dismiss_request": {
        "title": "Intenta ayudar a los demás miembros"
      },
      "publish_offer": {
        "description": "Publica un objeto específico, o elige entre los objetos sugeridos ya compartidos por nuestros miembros."
      },
      "send_message": {
        "description": "¡Rompe el hielo! Escribe a un miembro para ofrecer tu ayuda o para saber más sobre un anuncio."
      }
    },
    "neighbourhoodFirstShare": "En tu barrio, <strong>{{percent}}% de los demás miembros</strong> hicieron su primer intercambio <strong>en menos de una semana</strong>",
    "objectiveDetails": "El objetivo del mes se determina en función del número de miembros que comparten a tu alrededor y la madurez de tu comunidad.",
    "seriesDetails": "Para mantener viva la llama del compartir, tú y los demás miembros deben alcanzar el objetivo de compartidos indicado para el mes.",
    "tips": {
      "helpNeighbours": {
        "title": "Intenta ayudar a los demás miembros"
      }
    }
  }
}
